import { useEffect } from 'react';

const DEFAULT_TITLE =
  'MyRDP | Ryzen 9 9950X High-Performance RDP & VPS Hosting';
const DEFAULT_DESC =
  'High-performance cloud VPS and remote desktop hosting in the USA and Netherlands. SSD storage, DDoS protection, and crypto top-ups—deploy in minutes with MyRDP.';

export function usePageSeo({ title, description, keywords, canonicalPath }) {
  useEffect(() => {
    document.title = title ? `${title} | MyRDP` : DEFAULT_TITLE;

    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    if (description) metaDesc.setAttribute('content', description);
    else metaDesc.setAttribute('content', DEFAULT_DESC);

    const kwStr = Array.isArray(keywords) ? keywords.join(', ') : keywords || '';
    let metaKw = document.querySelector('meta[name="keywords"]');
    if (kwStr) {
      if (!metaKw) {
        metaKw = document.createElement('meta');
        metaKw.setAttribute('name', 'keywords');
        document.head.appendChild(metaKw);
      }
      metaKw.setAttribute('content', kwStr);
    } else if (metaKw) {
      metaKw.remove();
    }

    let linkCanonical = document.querySelector('link[rel="canonical"]');
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    if (canonicalPath && origin) {
      if (!linkCanonical) {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        document.head.appendChild(linkCanonical);
      }
      linkCanonical.setAttribute('href', `${origin}${canonicalPath}`);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      metaDesc.setAttribute('content', DEFAULT_DESC);
      if (metaKw) metaKw.remove();
      if (linkCanonical && canonicalPath) linkCanonical.remove();
    };
  }, [title, description, keywords, canonicalPath]);
}
